import styled, { css, keyframes } from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

const show = keyframes`
   0% {
      opacity: 0;
   }
   70% {
      opacity: 0;
   }
   100% {
      opacity: 1;
   }
`;

type StyledContainerProps = { $open: boolean; $backgroundColor: string };

export const StyledContainer = styled(StyledFlex)<StyledContainerProps>`
   box-sizing: border-box;
   overflow: hidden;
   width: 38px;
   height: 38px;
   margin: 0 0 0 6px;
   padding: 0;
   border-radius: 50%;
   background-color: transparent;
   transition: background-color 0.4s ease-out;

   ${(props) =>
      props.$open &&
      css`
         width: 156px;
         flex-shrink: 0;
         height: auto;
         min-height: 124px;
         padding: 12px 8px;
         border-radius: 20px;
         background-color: ${props.$backgroundColor};
      `}
`;

StyledContainer.displayName = 'StyledContainer';

export const StyledCollapsedIcon = styled(StyledFlex)`
   line-height: 0;
   cursor: pointer;
`;

StyledCollapsedIcon.displayName = 'StyledCollapsedIcon';

export const StyledContent = styled.div<{ $animate: boolean }>`
   width: 100%;

   ${(props) =>
      props.$animate &&
      css`
         opacity: 0;
         animation: ${show} 0.4s ease-out forwards;
      `}
`;

StyledContent.displayName = 'StyledContent';
